"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TagList_1 = __importDefault(require("./TagList"));
var selectors_1 = require("../selectors");
var styled_components_1 = __importDefault(require("styled-components"));
var TagCloud = function () {
    var tags = (0, selectors_1.useTagCloudSelector)();
    return (react_1.default.createElement(TagCloudWrapper, null,
        react_1.default.createElement(TagList_1.default, { visible: !!tags.length, tags: tags, tagClick: function () { return function () { }; } })));
};
var TagCloudWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n\n  a {\n    padding: 2px 12px;\n    color: ", ";\n    background-color: ", ";\n    font-weight: 400;\n    border-radius: 4px;\n    margin-right: 8px;\n    margin-top: 12px;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n\n  a {\n    padding: 2px 12px;\n    color: ", ";\n    background-color: ", ";\n    font-weight: 400;\n    border-radius: 4px;\n    margin-right: 8px;\n    margin-top: 12px;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), function (p) { return p.theme.colors.secondary; }, function (p) { return p.theme.colors.bg.secondary; }, function (p) { return p.theme.colors.brand; });
exports.default = TagCloud;
var templateObject_1;
